import { Routes } from '@angular/router';
import { loggedinGuard } from './core/guards/loggedin.guard';
import { DashboardComponent } from './dashboard/dashboard/dashboard.component';
import { LoginComponent } from './login/login/login.component';
import { LogoutComponent } from './login/logout/logout.component';
import { PwChangedComponent } from './login/pw-changed/pw-changed.component';
import { NotFoundComponent } from './notfound/not-found/not-found.component';

export const routes: Routes = [
  { path: '', component: DashboardComponent, canActivate: [loggedinGuard] },
  { path: 'dashboard', component: DashboardComponent, canActivate: [loggedinGuard] },
  { path: 'login', component: LoginComponent },
  { path: 'logout', component: LogoutComponent },
  { path: 'pwchanged', component: PwChangedComponent },
  {
    path: 'adresse',
    canActivate: [loggedinGuard],
    loadChildren: () => import('./modules/adresse/adresse.routes').then((m) => m.SETTINGS_ROUTES),
  },
  {
    path: 'projekt',
    canActivate: [loggedinGuard],
    loadChildren: () => import('./modules/projekt/projekt.routes').then((m) => m.SETTINGS_ROUTES),
  },
  {
    path: 'arp',
    canActivate: [loggedinGuard],
    loadChildren: () => import('./modules/arp/arp.routes').then((m) => m.SETTINGS_ROUTES),
  },
  {
    path: 'urp',
    canActivate: [loggedinGuard],
    loadChildren: () => import('./modules/urp/urp.routes').then((m) => m.SETTINGS_ROUTES),
  },
  {
    path: 'baujournal',
    canActivate: [loggedinGuard],
    loadChildren: () => import('./modules/bj/bj.routes').then((m) => m.SETTINGS_ROUTES),
  },
  {
    path: 'qr',
    canActivate: [loggedinGuard],
    loadChildren: () => import('./modules/qr/qr.routes').then((m) => m.SETTINGS_ROUTES),
  },
  {
    path: 'einstellungen',
    canActivate: [loggedinGuard],
    loadChildren: () => import('./settings/settings.routes').then((m) => m.SETTINGS_ROUTES),
  },

  /* Page not Found */
  { path: '404', component: NotFoundComponent },
  { path: '**', redirectTo: '/404' },
];
